"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var clsx_1 = __importDefault(require("clsx"));
var context_1 = require("../../../../../contexts/appConfiguration/context");
var selectors_1 = require("../../../../../contexts/rubyJackpot/selectors");
var Swiper_1 = __importDefault(require("../../utils/Swiper/Swiper"));
var FeelingLuckyButton_1 = __importDefault(require("./FeelingLuckyButton"));
var GameSlide_1 = __importDefault(require("./GameSlide"));
var BigPostersContainer = function (_a) {
    var getRandomGame = _a.getRandomGame, isMobile = _a.isMobile, _b = _a.show, show = _b === void 0 ? true : _b;
    var rubyMainDomain = (0, context_1.useAppConfig)().rubyMainDomain;
    var games = (0, selectors_1.useGames)();
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: (0, clsx_1.default)("container-posters", show && "container-posters--show") }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "container-posters-inline-items" }, { children: [(0, jsx_runtime_1.jsx)("span", { children: "Jocuri participante" }), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "container-posters-grouped" }, { children: [!isMobile && (0, jsx_runtime_1.jsx)(FeelingLuckyButton_1.default, { getRandomGame: getRandomGame }), (0, jsx_runtime_1.jsx)("button", __assign({ type: "button", className: "games-button" }, { children: (0, jsx_runtime_1.jsxs)("a", __assign({ target: "_parent", href: "".concat(rubyMainDomain, "/rubyJackpot-games") }, { children: ["Toate (", games.length, ")"] })) }))] }))] })), (0, jsx_runtime_1.jsx)(Swiper_1.default, __assign({ breakpoints: {
                    320: {
                        slidesPerView: 3,
                    },
                    640: {
                        slidesPerView: 2.5,
                    },
                    1200: {
                        slidesPerView: 3.5,
                    },
                }, slidesPerView: 3.5 }, { children: games.map(function (game, index) {
                    return (0, jsx_runtime_1.jsx)(GameSlide_1.default, { game: game }, "game-".concat(index));
                }) }))] })));
};
exports.default = BigPostersContainer;
